import quickFetch from 'quick-fetch';
export const getEarlyRequestResult = (name, fallbackFetcher) => {
  const earlyRequest = name && quickFetch.getRequestStateByName(name);
  if (!earlyRequest) {
    if (!fallbackFetcher) {
      throw new Error('No fallback fetcher provided');
    }
    return fallbackFetcher();
  }
  return new Promise((resolve, reject) => {
    earlyRequest.whenFinished(result => {
      quickFetch.removeEarlyRequest(name);
      resolve(result);
    });
    earlyRequest.onError((__xhr, errorMessage) => {
      quickFetch.removeEarlyRequest(name);
      reject(new Error(errorMessage));
    });
  });
};
export const getChirpEarlyRequest = (name, fallbackFetcher) => {
  const requestState = name && quickFetch.getRequestStateByName(name);
  if (requestState && !requestState.error) {
    return new Promise((resolve, reject) => {
      requestState.whenFinished(response => {
        quickFetch.removeEarlyRequest(name);
        // Quick fetch + chirp responses are always strings and need to be accessed via response.data
        resolve(JSON.parse(response).data);
      });
      requestState.onError((xhr, errorMessage) => {
        quickFetch.removeEarlyRequest(name);
        try {
          const parsed = JSON.parse(xhr.responseText);
          if (typeof parsed === 'object' && (parsed.type === 'rpcError' || parsed.type === 'internalError')) {
            resolve(parsed);
          } else {
            reject(errorMessage);
          }
        } catch (e) {
          reject(errorMessage);
        }
      });
    });
  }
  if (!fallbackFetcher) {
    throw new Error('No fallback fetcher provided');
  }
  return fallbackFetcher();
};